import React from 'react';
import { WHATSAPP_URL } from '../utils/whatsapp';

function Intro() {
  return (
    <section className="intro section-wrap" id="about">
      <div>
        <span className="eyebrow">01 / The studio</span>
        <h2>Not just how it looked.<br /><em>How it felt.</em></h2>
      </div>
      <div className="intro-right">
        <p>
          We make photographs that feel as alive as the day itself. The elegant, the unexpected, the beautifully imperfect — all held with care, exactly as they happened, so the smallest glance can bring the whole day rushing back.
        </p>
        <a
          className="underlined-link"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Our philosophy <span>↗</span>
        </a>
      </div>
    </section>
  );
}

export default Intro;
